<template>
    <div>
        <top></top>
        <Compress></Compress>
    </div>
</template>

<script>
import Top from '../components/common/Top.vue'
import Compress from '../components/Compress.vue'
export default {
    name: 'Compress-view',
    components: {
        Top, Compress
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
